// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const VulnerabilitiesIcon = createSvgIcon(
  <svg width={24} height={24} fill="currentColor" viewBox="0 0 24 24">
    <path d="m12 3.44 7.56 3V11c0 4.32-3.46 8.4-7.56 9.57-4.1-1.18-7.56-5.26-7.56-9.57V6.48l7.56-3M12 2q-.3 0-.56.11L3.87 5.16A1.4 1.4 0 0 0 3 6.48V11c0 5 3.85 9.59 8.61 11q.39.12.78 0C17.15 20.58 21 16 21 11V6.48a1.4 1.4 0 0 0-.87-1.32l-7.57-3.05q-.27-.1-.56-.11" />
    <path d="M15 13h1.5a.5.5 0 0 0 0-1H15v-1h1.5a.5.5 0 0 0 0-1h-1.68a3 3 0 0 0-1.1-1.43L15 7.27a.5.5 0 0 0-.7-.71l-1.55 1.51a3 3 0 0 0-1.48.03l-1.5-1.54a.5.5 0 0 0-.85.35.5.5 0 0 0 .15.36l1.23 1.24q-.77.55-1.1 1.43H7.5a.5.5 0 1 0 0 1H9v1H7.5a.5.5 0 0 0 0 1H9v1H7.5a.5.5 0 0 0 0 1h1.7a3 3 0 0 0 2.3 1.93v-5.14a.5.5 0 0 1 1 0v5.18A3 3 0 0 0 14.82 15h1.68a.5.5 0 0 0 0-1H15z" />
  </svg>,
  "Vulnerabilities",
);
export default VulnerabilitiesIcon;
